import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["requiredInput"]

  connect() {
    this.boundSubmit = this.handleSubmit.bind(this)
    this.boundInput = this.handleInput.bind(this)
    this.element.addEventListener("submit", this.boundSubmit)
    this.element.addEventListener("input", this.boundInput)
    this.validateAndToggle()
  }

  disconnect() {
    if (this.boundSubmit) {
      this.element.removeEventListener("submit", this.boundSubmit)
    }
    if (this.boundInput) {
      this.element.removeEventListener("input", this.boundInput)
    }
  }

  handleSubmit(event) {
    if (this.hasMissingRequired()) {
      event.preventDefault()
      event.stopPropagation()
      this.showMessage()
    }
  }

  handleInput() {
    this.validateAndToggle()
  }

  validateAndToggle() {
    const missingRequired = this.hasMissingRequired()
    const ecoInvalid = this.hasPartialEco()
    const missing = missingRequired || ecoInvalid
    const buttons = this.element.querySelectorAll('input[type="submit"], button[type="submit"]')
    buttons.forEach(btn => {
      btn.disabled = missing
    })

    this.requiredInputTargets.forEach(input => {
      const wrapper = input.closest('.form-input')
      if (!wrapper) return
      if (missing && (input.value === '' || input.value === null || input.value === undefined)) {
        wrapper.classList.add('field-error')
      } else {
        wrapper.classList.remove('field-error')
      }
    })

    const ecoInputs = this.getEcoInputs()
    ecoInputs.forEach(input => {
      const wrapper = input.closest('.form-input')
      if (!wrapper) return
      if (ecoInvalid && (input.value === '' || input.value === null || input.value === undefined)) {
        wrapper.classList.add('field-error')
      } else {
        wrapper.classList.remove('field-error')
      }
    })

    this.dispatch("state", {
      bubbles: true,
      detail: { missing }
    })
  }

  hasMissingRequired() {
    return this.requiredInputTargets.some(input => input.value === '' || input.value === null || input.value === undefined)
  }

  hasPartialEco() {
    const ecoInputs = this.getEcoInputs()
    if (ecoInputs.length === 0) return false
    const filled = ecoInputs.filter(input => input.value !== '' && input.value !== null && input.value !== undefined)
    return filled.length > 0 && filled.length < ecoInputs.length
  }

  getEcoInputs() {
    return Array.from(this.element.querySelectorAll("input[name*='[eco']"))
  }

  showMessage() {
    const existing = document.querySelector('.speeds-consumption-notice')
    if (existing) existing.remove()

    const notice = document.createElement('div')
    notice.className = 'settings-error-message notice speeds-consumption-notice'
    notice.textContent = 'Please fill all speed and consumption fields before calculating.'
    document.body.appendChild(notice)

    setTimeout(() => {
      if (notice && notice.parentNode) {
        notice.remove()
      }
    }, 4000)
  }
}
